import React, { useState, useEffect } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import SPFunctionsGrid from './spFunctionsGrid';
import { VIEW, UPDATE, DELETE, NEW } from '../../assets/Constants/actionsTypes';
import API from "../../services/api";
import validator from 'validator';
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import SPFunctionsModal from './spFunctionsModal';
import { useTranslation } from 'react-i18next';

const SPFunctions = () => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');

    // * defines whether or not to display the modal
    const [showModal, setShowModal] = useState(false);

    // * defines whether or not to display the modal
    const [showAlert, setShowAlert] = useState(false);

    // * list of spFunctions
    const [functionsList, setFunctionsList] = useState([]);

    // * spFunction selected in grid
    const [functionData, setFunctionData] = useState({});

    // * type of modal to be displayed
    const [viewType, setViewType] = useState('');

    // * we obtain the first time the spfunctions
    useEffect(() => {
        getFunctions();
    }, [])

    /**
     ** here you get the database spFunction
     */
    const getFunctions = async () => {
        setFunctionsList([]);
        try {
            // * call the api
            const res = await API.get('/spfunction/getall');
            setFunctionsList(res.data.data);
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    /**
     ** Show or hide the modal
     */
    const toggleWindow = () => {
        setShowModal(!showModal);
    }

    /**
     ** Show or hide the alert
     */
    const toggleAlert = () => {
        setShowAlert(!showAlert);
    }

    /**
     ** This function is in charge of managing which type of modal or alert should be opened.
     */
    const onActionClick = (actionItem, dataItme) => {
        const action = actionItem.value;
        setViewType(action);
        setFunctionData(dataItme);

        switch (action) {
            case NEW:
                toggleWindow();
                break;
            case VIEW:
                toggleWindow();
                break;
            case UPDATE:
                toggleWindow();
                break;
            case DELETE:
                toggleAlert();
                break;
            default:
                break;
        }
    }

    /**
     ** The upsert call is handled here
     */
    const onSave = async (data) => {
        try {
            // * validate required fiels
            if (validator.isEmpty(data.name)) {
                Notifications.notify(t('spFunction.name_required'), ERROR_NOTIFICATION);
                return;
            }

            // * we apply the trim to the fields
            data = {
                ...data,
                name: validator.trim(data.name),
                description: validator.trim(data.description)
            }

            // * call the api to do the upsert
            const res = await API.post('/spfunction/upsert', data);

            // * if errors exist, it is displayed as a notification
            if (res.data.code !== 100) {
                Notifications.notify(t(`spFunction.${res.data.code}`), ERROR_NOTIFICATION);
                return;
            }

            // * we decide what kind of message of success we should give
            const msg = data.spFunctionId === 0 ? t('spFunction.new_message') : t('spFunction.update_message');

            // * hide the modal and refresh the grid
            toggleWindow();
            Notifications.notify(msg, SUCCESS_NOTIFICATION);
            getFunctions();

        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }

    }

    /**
     ** The delete call is handled here
     */
    const onDelete = async () => {
        try {
            // * call the api to do the delete
            const res = await API.delete(`/spfunction?spFunctionId=${functionData.spFunctionId}`);

            // * if errors exist, it is displayed as a notification
            if (res.data.code !== 100) {
                Notifications.notify(t(`spFunction.${res.data.code}`), ERROR_NOTIFICATION);
                return;
            }

            // * hide the alert and refresh the grid
            toggleAlert();
            Notifications.notify(t('spFunction.delete_message'), SUCCESS_NOTIFICATION);
            getFunctions();
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e)
        }
    }

    return (
        <>
            <div className="sub_menu">
                <div className="sub_menu_btns my-1">
                    <button className="btn btn-primary ilo-btn" onClick={() => onActionClick({ value: NEW }, {})}>{t('spFunction.new_btn')}</button> | <span className="ilo-section-title p-1">{t('spFunction.modal_title')}</span>
                </div>
            </div>
            <div className="container-fluid mt-1">
                {/* modal window */}
                {showModal && <SPFunctionsModal type={viewType} data={functionData} toggleWindow={toggleWindow} onSave={onSave} />}

                {/* alert window */}
                {showAlert &&
                    <Dialog
                        className="ilo-delete-confirm"
                        title={t('spFunction.delete_title')}
                        onClose={() => toggleAlert()}
                    >
                        <p style={{ margin: "25px", textAlign: "center" }}>{t('spFunction.delete_body')}</p>
                        <DialogActionsBar layout="end">
                            <button className="k-button" onClick={onDelete}>{t('alerts.yes_btn')}</button>
                            <button className="k-button" onClick={toggleAlert}>{t('alerts.no_btn')}</button>
                        </DialogActionsBar>
                    </Dialog>
                }


                <div className="row">
                    {/* grid */}
                    <div className="container_grid">
                        <SPFunctionsGrid data={functionsList} onActionClick={onActionClick} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SPFunctions
